// extracted by mini-css-extract-plugin
export default {"container":"AccForm_container__k8r0s","title":"AccForm_title__nRQz5","actions":"AccForm_actions__tF-Lx"};